const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时爆料追踪',
    desc: '全网热点第一时间同步，从娱乐圈到社交平台，不错过任何一条劲爆黑料。24小时全天候更新，让你永远走在吃瓜最前线。',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '全民投票评选',
    desc: '社区驱动的黑料排位机制，每一票都真实有效。热门话题由吃瓜群众共同评选，公平公正，拒绝刷票和人工操控。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度吃瓜分析',
    desc: '多维度热点解读，从事件脉络到背后隐情，专业编辑团队为你梳理每一条爆料的前因后果，吃瓜也要吃得明明白白。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
            Features
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            平台特色
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl p-6 md:p-8 transition-all duration-300 hover:bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-5 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}